import { http, httpWithTimeout } from '@/utils/counter/http.js';

// 获取跳转url
export function getJumpToPayment() {
  return http.request({
    url: '/counter/merchant/auth/jumpToPayment',
    method: 'get',
  });
}

// 获取银行列表
export function getBankCounter(params) {
  return http.request({
    url: '/counter/front/merchant/bank',
    method: 'get',
    params,
  });
}

// 获取取款方式列表
export function getWithdrawalMethod() {
  return http.request({
    url: '/counter/front/merchant/withdrawalMethod',
    method: 'get',
  });
}

/**
 * 获取提现渠道
 */
export function getWithdrawalChannel(payTypeCode) {
  return http.request({
    url: '/counter/front/merchant/withdrawalChannel',
    method: 'get',
    params: {
      payTypeCode,
    },
  });
}

/**
 * 获取货币和汇率
 */
export function getCurrencyAndExchangeRate(payTypeCode, currencyType) {
  return http.request({
    url: '/counter/front/merchant/currencyAndExchangeRate',
    method: 'get',
    params: {
      payTypeCode,
      payType: currencyType,
    },
  });
}

/**
 * 存款方式列表
 */
export function getDepositMethod() {
  return http.request({
    url: '/counter/front/merchant/paymentMethod',
    method: 'get',
  });
}

// 存款下单
export function postPlacePayOrder(params) {
  return httpWithTimeout.request({
    url: '/counter/front/merchant/placePayOrder',
    method: 'post',
    data: params,
  });
}

/** 存款手机号弹窗校验*/
export function postDepositPhonePopupCheck() {
  return http.request({
    url: '/counter/front/merchant/depositPhonePopup/check',
    method: 'post',
  });
}

// 获取协议和汇率
export function getProtocol() {
  return http.request({
    url: '/counter/front/merchant/usdtProtocolAndExchangeRate',
    method: 'get',
  });
}

// 确认支付订单
export function postConfirmPayOrder(params) {
  return http.request({
    url: '/counter/front/merchant/confirmPayOrder',
    method: 'post',
    data: params,
  });
}

// 获取存款会员信息
export function getDepositMemberInfo() {
  return http.request({
    url: '/counter/front/merchant/getMemberInfo',
    method: 'get',
  });
}

// 获取收款码列表
export function postPaymentList(params = null) {
  return http.request({
    url: '/counter/front/payment/paymentList',
    method: 'get',
    params,
  });
}

// 删除收款码
export function postPaymentDelete(params) {
  return http.request({
    url: '/counter/front/payment/paymentDelete',
    method: 'post',
    data: params,
  });
}

// 添加或更新收款码
export function postPaymentAddOrUpdate(params) {
  return http.request({
    url: '/counter/front/payment/paymentAddOrUpdate',
    method: 'post',
    data: params,
  });
}

// 获取短信验证码
export function getSendPhoneSms(params) {
  return http.request({
    url: '/counter/front/payment/sendPhoneSms',
    method: 'post',
    data: params,
  });
}

// 取款下单
export function postPlaceTransferOrder(params) {
  return http.request({
    url: '/counter/front/merchant/placeTransferOrder',
    method: 'post',
    data: params,
  });
}

// 上传二维码图片
export function postUploadQRCode(params) {
  return http.request({
    url: '/counter/front/payment/uploadQRCode',
    method: 'post',
    iSupload: true,
    data: params,
    needAllData: true,
  });
}

// 跳转钱包订单页面
export function getJumpToWalletOrderSellPage(params) {
  return http.request({
    url: '/counter/front/merchant/jumpToWalletOrderSellPage',
    method: 'get',
    params: {
      payLevel: params.payLevel,
    },
  });
}

// 查询存款单信息
export function getPayOrderByMchOrderNo(orderNo) {
  return http.request({
    url: '/counter/front/merchant/getPayOrderByMchOrderNo',
    method: 'get',
    params: {
      mchOrderNo: orderNo,
    },
  });
}

// 查询取款单信息
export function getTransferOrderByMchOrderNo(orderNo) {
  return http.request({
    url: '/counter/front/merchant/getTransferOrderByMchOrderNo',
    method: 'get',
    params: {
      mchOrderNo: orderNo,
    },
  });
}

// 获取处理中的存款单
export function getProcessingPayOrder(params) {
  return http.request({
    url: '/counter/front/merchant/getProcessingPayOrder',
    method: 'post',
    data: params,
  });
}

// 查询下单未操作的存款单
export function getForceContinuePayOrder(params) {
  return http.request({
    url: '/counter/front/merchant/getForceContinuePayOrder',
    method: 'get',
    params,
  });
}

// 取消存款单
export function getCancelPayOrderByMerchant(params) {
  return http.request({
    url: '/counter/front/merchant/cancelPayOrderByMerchant',
    method: 'get',
    params,
  });
}

// 获取倒计时时间
export function getConfig(params) {
  return http.request({
    url: '/counter/front/merchant/getConfig',
    method: 'get',
    params,
  });
}

// 取消订单
export function getCancelProcessingPayOrder(params) {
  return http.request({
    url: '/counter/front/merchant/cancelProcessingPayOrder',
    method: 'get',
    params,
  });
}

// 获取取消存款单枚举
export function getCancelPayOrderEnum() {
  return http.request({
    url: '/counter/front/merchant/cancelPayOrderEnum',
    method: 'get',
  });
}

// 获取取款方式列表
export function getpaymentListDZQB() {
  return http.request({
    url: '/counter/front/payment/paymentListDZQB',
    method: 'get',
  });
}

// 获取余额
export function getAvailableBalance() {
  return http.request({
    url: '/counter/front/merchant/getAvailableBalance',
    method: 'get',
  });
}

// 获取支付枚举
export function getPaymentEnum(params = null) {
  return http.request({
    url: '/counter/front/payment/paymentEnum',
    method: 'get',
    params,
  });
}

// 长传凭证
export function uploadVoucherFile(params) {
  return http.request({
    url: '/counter/front/merchant/uploadVoucherFile',
    method: 'post',
    iSupload: true,
    data: params,
  });
}

// 获取钱包类型
export function getQueryWalletMember(params = null) {
  return http.request({
    url: '/counter/front/merchant/queryWalletMember',
    method: 'get',
    params,
  });
}

// 获取固码模式列表
export function getSplitFixedAmount(params) {
  return http.request({
    url: '/counter/front/merchant/splitFixedAmount',
    method: 'get',
    params,
  });
}

// 上传固码二维码
export function uploadFixedAmountQRCode(params) {
  return http.request({
    url: '/counter/front/merchant/uploadFixedAmountQRCode',
    method: 'post',
    iSupload: true,
    data: params,
  });
}

// 获取处理统计
export function getProcessStatic(params = null) {
  return http.request({
    url: '/counter/front/merchant/getProcessStatic',
    method: 'get',
    params,
  });
}

// 获取客服url
export function getCounterKfLink(params) {
  return http.request({
    url: '/counter/front/merchant/getKfLink',
    method: 'post',
    data: params,
  });
}

/** 支付宝任务登录跳转链接；silent：预取/静默刷新失败不弹 toast */
export function getAlipayJobLoginToken(config = {}) {
  return http.request({
    url: '/counter/front/merchant/alipayJobLoginToken',
    method: 'post',
    alipayJobSilent: !!config.silent,
  });
}

/** 取款页：支付宝任务审核通过通知领取 */
export function postAlipayJobTaskNoticeClaim() {
  return http.request({
    url: '/counter/front/merchant/alipayJobTaskNoticeClaim',
    method: 'post',
  });
}

// 收银台 买入订单
export function buyPageFund(data) {
  return http.request({
    url: '/counter/front/merchant/buyPageFund',
    method: 'post',
    data,
  });
}

export function pageFundCounter(data) {
  return http.request({
    url: '/counter/front/merchant/sellPageFund',
    method: 'post',
    data,
  });
}

/**
 * 获取手机号
 */
export function mchMemberPhone() {
  return http.request({
    url: '/counter/front/payment/mchMemberPhone',
    method: 'get',
  });
}

// 获取是否绑定真实姓名
export function getMerchantMchConfig() {
  return http.request({
    url: '/counter/front/merchant/mchConfig',
    method: 'get',
  });
}

// 查询银行卡账户姓名（收银台添加银行卡时默认户名，替代原 paymentList 中 accountName）
export function queryBankAccountName() {
  return http.request({
    url: '/counter/front/payment/bankAccountName',
    method: 'get',
    // 无默认姓名时后端可能 { code:0, data:null, msg:'操作成功' }，避免走 http 层「空 data」当失败弹窗
    allowEmptySuccess: true,
  });
}
// 获取钱包地址
export function jumpToOrderUrl(params = null) {
  return http.request({
    url: '/counter/front/order/jumpToOrderUrl',
    method: 'get',
    params,
  });
}

// 68C存款下单-查询钱包余额
export function merchantPlaceWallet(data) {
  return http.request({
    url: '/counter/front/merchant/placeWallet',
    method: 'post',
    data,
    needAllData: true,
  });
}

/** 启用钱包支付前查询已绑定钱包余额（GET，返回 data 为余额数值） */
export function queryBindWalletBalance(params) {
  return http.request({
    url: '/counter/front/order/queryBindWalletBalance',
    method: 'get',
    params,
    needAllData: true,
    toast: false,
  });
}

// 风控触发
export function checkNeedGeeTest(data) {
  return http.request({
    url: '/counter/front/merchant/checkNeedGeeTest',
    method: 'post',
    data,
    needAllData: true,
  });
}

/**
 * 获取一键退回开关（0 不显示退回账户按钮，1 显示）
 */
export function getOneClickRefundSwitch() {
  return http.request({
    url: '/counter/front/sell/custom/oneClickRefundSwitch',
    method: 'get',
    toast: false,
  });
}

/**
 * 获取会员审核中金额
 */
export function getMemberUnderReviewAmounts(params = {}) {
  return http.request({
    url: '/counter/front/sell/custom/memberUnderReviewAmounts',
    method: 'get',
    params,
    toast: false,
  });
}

/**
 * 获取用户可退款列表（弹窗列表）
 */
export function getRefundList(params = {}) {
  return http.request({
    url: '/counter/front/sell/custom/refundList',
    method: 'get',
    params,
    toast: true,
  });
}

// 获取放币确认选项
export function getConfirmSellOrderOption(data) {
  return http.request({
    url: '/order/chat/auth/getConfirmSellOrderOption',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 退回（点击回退按钮时调用）
 */
export function sellRefund(data = {}) {
  return http.request({
    url: '/counter/front/sell/custom/sellRefund',
    method: 'post',
    data,
    toast: false,
    needAllData: true,
  });
}

/**
 * 退回配置（获取限制小时数等）
 */
export function getSellRefundConfig() {
  return http.request({
    url: '/counter/front/sell/custom/sellRefundConfig',
    method: 'post',
    data: {},
    toast: false,
  });
}

// 验证放币确认选项
export function verifyConfirmSellOrderOption(data) {
  return http.request({
    url: '/order/chat/auth/verifyConfirmSellOrderOption',
    method: 'post',
    data,
    needAllData: true,
  });
}

// 支付密码校验（放币成功后同步状态）
export function checkPayPass(data) {
  return http.request({
    url: '/order/chat/auth/checkPayPass',
    method: 'post',
    data,
    toast: true,
  });
}
// 取款优惠提示弹窗
export function dealReminder() {
  return http.request({
    url: '/counter/front/order/dealReminder',
    method: 'post',
    data: {},
    needAllData: true,
  });
}
// 存款优惠提示弹窗
export function depositReminder() {
  return http.request({
    url: '/counter/front/order/depositReminder',
    method: 'post',
    data: {},
    needAllData: true,
  });
}
// 获取银行列表
export function getNotice(params) {
  return http.request({
    url: '/counter/front/merchant/notice',
    method: 'get',
    params,
    needAllData: true,
  });
}
